import { useEffect, useRef } from 'react'
import { useDelayedValue } from '@10000/react'
import { Box } from './'
import './PopOver.scss'

export const PopOver = ({ open, onClose, items, className, ...props }) => {
  const popoverRef = useRef()
  const opacity = useDelayedValue(open, { true: 5 }) ? 1 : 0
  const show = useDelayedValue(open, { false: 250 })

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose])

  return (
    <Box
      className={`popover-container${className ? ` ${className}` : ''}`}
      ref={popoverRef}
    >
      <Box
        className="popover-content"
        opacity={opacity}
        transition={0.25}
        display={show ? 'flex' : 'none'}
        {...props}
      >
        {items.map((item, index) => (
          <Box key={index} fullWidth pt={4} pb={4}>
              <Box
                fullWidth
                className="popover-item"
                textAlign="left"
                onClick={(e) => {
                  e.stopPropagation()
                  item.onClick()
                  onClose(e)
                }}
              >
                {item.text}
              </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}